module.exports = __webpack_public_path__ + "media/images/profile/multi-images-a5d92158e6d9d55117e657a997ce2c2d.svg";